import { useTranslation } from 'react-i18next';

const useFormUtils = () => {
  const { t } = useTranslation();

  const getFieldError = ({ errors, fieldName }) => (
    errors?.[fieldName]?.message
      ? t(errors[fieldName].message.toString())
      : null
  );

  return {
    getFieldError,
  };
};

export default useFormUtils;
